import { useEffect, useState } from "react";

const SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";

/**
 * Lazily loads the Razorpay Checkout script once and exposes a ready flag.
 * Safe to call from any component; script tag is shared across mounts.
 */
export default function useRazorpayScript() {
    const [ready, setReady] = useState(() =>
        typeof window !== "undefined" && !!window.Razorpay,
    );

    useEffect(() => {
        if (ready) return;
        let existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
        const onLoad = () => setReady(true);
        const onErr = () => setReady(false);

        if (!existing) {
            existing = document.createElement("script");
            existing.src = SCRIPT_URL;
            existing.async = true;
            existing.addEventListener("load", onLoad);
            existing.addEventListener("error", onErr);
            document.body.appendChild(existing);
        } else if (window.Razorpay) {
            setReady(true);
        } else {
            existing.addEventListener("load", onLoad);
            existing.addEventListener("error", onErr);
        }

        return () => {
            existing?.removeEventListener("load", onLoad);
            existing?.removeEventListener("error", onErr);
        };
    }, [ready]);

    return ready;
}
